// extracted by mini-css-extract-plugin
export default {"user_outer_container":"User_user_outer_container__LUWu5"};